var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "iframe-frame" }, [
    _c("div", { staticClass: "desktop-iframe video" }, [
      _c("iframe", {
        attrs: {
          src: _vm.desksrc,
          frameborder: "0",
          allowfullscreen: "",
          loading: "lazy"
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mobile-iframe video" }, [
      _c("iframe", {
        attrs: {
          src: _vm.mobsrc,
          frameborder: "0",
          allowfullscreen: "",
          loading: "lazy"
        }
      }),
      _vm._v(" "),
      !_vm.mobsrc
        ? _c("div", {
            staticClass: "mobile-iframe-img",
            on: { click: _vm.loadMobile }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }